module.exports = __webpack_public_path__ + "img/healthcare-pathway.4357a4f2.jpg";